import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '../Typography';
import SvgComponent from '../SvgComponent';
import VapSprite from '@quikr/ui/src/assets/vap-homes-sprite.svg';

const Span = styled(Typography)`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.Pentanary};
`;

const WrapProperty = styled.div`
  flex: 4;
  @media (max-width: 767px) {
    flex: 0 0 auto;
    padding 0 20px;
  }
`;

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.TopFeatureGradient};
  border-radius: 4px;
  padding-top: 16px;
  margin: 24px 0 0;
  height: 120px;
  @media (max-width: 767px) {
    margin: 24px -12px -25px;
    overflow-x: scroll;
    border-radius: 0;
  }
`;

const LowerSpan = styled(Typography)`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.colors.TextDelta};
`;

const Circle = styled.span`
  position: relative;
  width: 45px;
  height: 45px;
  background: #fff;
  border-radius: 50%;
  margin-bottom: 7px;
`;

const Svg = styled(SvgComponent)`
  width: 60px;
  height: 40px;
  position: absolute;
  left: -7px;
  top: 2px;
`;

const ICON_MAPPING = {
  Bedrooms: 'ic_bedroom',
  Bathrooms: 'ic_bathroom',
  'Land Area': 'ic_buildup',
  'Built-Up Area': 'ic_buildup',
  'Plot Area': 'ic_buildup',
  'Available From': 'ic_available_from'
};

const TopFeature = ({ features }) => {
  if (features && features.length > 0) {
    return (
      <Wrapper className="dF">
        {features.map((each, index) => (
          <WrapProperty className="dFA fdC" key={index}>
            <Circle>
              <Svg svgSprite={VapSprite} id={ICON_MAPPING[each.key]}></Svg>
            </Circle>
            <Span tagName="span" modifiers={['bt2', 'medium']}>
              {each.value}
            </Span>
            <LowerSpan tagName="span" modifiers={['bt3']}>
              {each.subtext}
            </LowerSpan>
          </WrapProperty>
        ))}
      </Wrapper>
    );
  }
  return null;
};

TopFeature.propTypes = {
  features: PropTypes.array
};

TopFeature.defaultProps = {
  features: []
};

export default TopFeature;
